import { IconButton, Snackbar, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { uiActions, useAction, useSelector, AppState } from "../state";
import { useMobile } from "../themes";
const Notification = () => {
  const notification = useSelector((state: AppState) => state.ui.notification);
  const hideNotification = useAction(uiActions.hideNotification);
  const isMobile = useMobile();
  return (
    <Snackbar
      open={!!notification}
      onClose={hideNotification}
      autoHideDuration={notification?.duration || 5000}
      message={notification?.message}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      {notification?.variant && (
        <Alert
          severity={notification.variant}
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={hideNotification}
            >
              <CloseIcon
                fontSize="small"
                style={{ fontSize: isMobile ? "1rem" : ".5em" }}
              />
            </IconButton>
          }
        >
          {notification.message}
        </Alert>
      )}
    </Snackbar>
  );
};
export default Notification;
